import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'textHighlight'
})

export class TextHighlightPipe implements PipeTransform {

    constructor(
        private sanitizer: DomSanitizer
    ) { }


    transform(value: string, searchString: string): SafeHtml {
        if (!!searchString) {

            const lowercasedValue = value.toLowerCase();
            const lowerCaseSearchStrings = searchString.toLowerCase().split(' ').map(w => w.trim()).filter(w => !!w);

            let tempValue: string = lowercasedValue

            lowerCaseSearchStrings.forEach((searchKeyword: string) => {

                tempValue = tempValue.replace(new RegExp(searchKeyword, 'gi'), (match: any) => `@@${match}%%`);
            })
            let startCopy = tempValue.replace(/%%/g, '')
            let endCopy = tempValue.replace(/@@/g, '')


            let startSections = startCopy.split('@@');
            let endSections = endCopy.split('%%');
            let startCharacterIndexes: number[] = startSections.map((section: string, index: number) => {

                const existingTotal: number = startSections.reduce((acc: number, curr: string, currIndex: number) => {
                    if (currIndex < index) {
                        return acc + curr.length
                    }
                    else {
                        return acc
                    }
                }, 0);
                return existingTotal + section.length
            })
            let endCharacterIndexes = endSections.reduce((acc: number[], curr: string, index: number) => {

                const existingTotal: number = endSections.reduce((acc: number, curr: string, currIndex: number) => {
                    if (currIndex < index) {
                        return acc + curr.length
                    }
                    else {
                        return acc
                    }
                }, 0);
                return [...acc, existingTotal + curr.length]
            }, []);

            let newString = '';

            for (let i = 0; i < value.length; i++) {

                if (startCharacterIndexes.includes(i)) {
                    newString += '<span class="text-highlight">'
                }
                if (endCharacterIndexes.includes(i)) {
                    newString += '</span>'
                }
                newString += value[i];

            }
            return this.sanitizer.bypassSecurityTrustHtml(newString);
        }
        else {

            return value

        }

    }
}